import React from 'react';
import { ExternalLink } from '../../global/components/external-link-modal';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { BannerAd, MyCpgPodsSettings } from './mycpg-pod-models';

interface Props {
    settings: MyCpgPodsSettings;
}
export function MyCpgHero(props: Props) {

    const { settings } = props;
    const now = new Date();

    function IsBannerActive(banner: BannerAd) : boolean {
        if (!banner) return false;

        const startDate = banner.startDate ? new Date(banner.startDate) : null;
        const endDate = banner.endDate ? new Date(banner.endDate) : null;

        if ((startDate && now < startDate) || (endDate && now > endDate)) return false;

        return true;
    }

    function SelectBanner() : BannerAd {

        if (settings.bannersArea){            
            for (let i = 0; i < settings.bannersArea.length; i += 1) {
                if (IsBannerActive(settings.bannersArea[i])){
                    return settings.bannersArea[i];
                }                                
            }
        }

        return {
            imageUrl: settings.heroImage,
            imageAltText: settings.heroImageAltText,
            title: settings.heroTitle,
            subtitle: settings.heroSubtitle,
            buttonText: settings.ctaButtonText,
            link: settings.ctaLink,
            startDate: null,
            endDate: null,
        };
    }

    const selectedBanner = SelectBanner();

    if (!selectedBanner) return null;

    return (
        <ContentSpacer>
            <div className='pods-hero'>
                <div className='pods-hero-image'>
                    <img src={selectedBanner.imageUrl} alt={selectedBanner.imageAltText} />
                </div>
                <div className='pods-hero-content'>
                    <div>
                        <div className='pods-hero-content-inner rich-text'>
                            <p className='pods-hero-preheader'>{selectedBanner.title}</p>
                            <h2 className='pods-hero-title'>{selectedBanner.subtitle}</h2>
                        </div>

                        <ExternalLink
                            linkText={
                                <>
                                    {selectedBanner.buttonText}
                                    <svg className='icon' aria-hidden='true' focusable='false'>
                                        <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#icon-arrow-right' />
                                    </svg>
                                </>
                            }
                            linkUrl={selectedBanner.link}
                            className='pods-hero-cta btn-secondary'
                        />
                    </div>
                </div>
            </div>
        </ContentSpacer>
    );
}
